module.exports = __webpack_public_path__ + "img/diagram_11_1.acef4556.png";